import { render, staticRenderFns } from "./GlBalanceHistoryReport.vue?vue&type=template&id=81fca308&scoped=true&"
import script from "./GlBalanceHistoryReport.vue?vue&type=script&lang=js&"
export * from "./GlBalanceHistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./GlBalanceHistoryReport.vue?vue&type=style&index=0&id=81fca308&lang=scss&scoped=true&"
import style1 from "./GlBalanceHistoryReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fca308",
  null
  
)

export default component.exports